import { Box, BoxProps } from '@chakra-ui/react'

function CrossSvg({ ...props }: BoxProps) {
    return (
        <Box {...props}>
            <svg width="100%" height="100%" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" width="16" height="16" rx="4.92308" fill="#CDD6DC" />
                <path fillRule="evenodd" clipRule="evenodd" d="M5.41092 4.91068C5.53108 4.79052 5.7259 4.79052 5.84606 4.91068L8.50029 7.5649L11.1545 4.91068C11.2747 4.79052 11.4695 4.79052 11.5897 4.91068C11.7098 5.03084 11.7098 5.22566 11.5897 5.34582L8.93543 8.00004L11.5897 10.6543C11.7098 10.7744 11.7098 10.9692 11.5897 11.0894C11.4695 11.2096 11.2747 11.2096 11.1545 11.0894L8.50029 8.43518L5.84606 11.0894C5.7259 11.2096 5.53108 11.2096 5.41092 11.0894C5.29076 10.9692 5.29076 10.7744 5.41092 10.6543L8.06515 8.00004L5.41092 5.34582C5.29076 5.22566 5.29076 5.03084 5.41092 4.91068Z" fill="#18191B" />
            </svg>
        </Box>
    )
}

export { CrossSvg }
